import React from 'react';
import TextField from 'material-ui/TextField';

import './styles.css';

const FreeformFilterItem = props => {
  function searchChanged(event) {
    let value = [];
    if (event.target.value) {
      value = [event.target.value];
    }
    props.onChange({
      name: props.filterName,
      values: value
    });
  }

  return (
    <TextField
      title={`Search with: ${props.fieldNames.join(', ')}`}
      hintText={props.label}
      value={props.values[0] || ''}
      onChange={searchChanged}
      className="FreeformFilterItem"
    />
  );
};

export default FreeformFilterItem;



// WEBPACK FOOTER //
// ./src/components/filter/FreeformFilterItem.js